import { BaseDisplayer } from './BaseDisplayer';
import { ValueType } from '../FormatterTypes';
import { asInt, intToStrEx2, hasValue } from '../Utils/ValueUtils';
import {
  formatterStrParamDef,
  formatterBoolParamDef,
} from '../Utils/ParamUtils';

class TEDDisplayMinutes extends BaseDisplayer {
  public static getInstance(): TEDDisplayMinutes {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayMinutes;

  defaultParams(): string {
    return 'TimeSep=":";ThousandSep=" ";ShowZeroAsBlank="N";';
  }

  display(value: ValueType, displayText: boolean = false, params: string) {
    let result = '';
    if (hasValue(value)) {
      let m = asInt(value);
      let neg: boolean;
      const showZeroAsBlank = formatterBoolParamDef(
        'ShowZeroAsBlank',
        params,
        this.defaultParams()
      );
      if (!(m === 0 && displayText && showZeroAsBlank)) {
        neg = m < 0;
        if (neg) {
          m = -m;
        }

        const thousandSep = formatterStrParamDef(
          'ThousandSep',
          params,
          this.defaultParams()
        );
        let h: number = Math.floor(m / 60);
        m = m % 60;
        result = neg ? '-' : '';
        result += intToStrEx2(
          h,
          1,
          Number.MAX_SAFE_INTEGER,
          displayText ? thousandSep : '',
          false
        );
        result += formatterStrParamDef('TimeSep', params, this.defaultParams());
        result += intToStrEx2(m, 2, 2);
      }
    }
    return result;
  }
}

export { TEDDisplayMinutes };
